<div class="header">
  <h3>My Assignments</h3>
</div>

@if (errorMessage) {
  <div class="alert alert-danger">{{errorMessage}}</div>
}

@if (engagement) {
  <div class="row phase8-inspection">
    <aside class="col sidebar sidebar-tree-view">
      <div class="sidebar-inner">
        <div class="form-group">
          <button type="button" class="btn btn-sm btn-secondary mr-1" (click)="topics.forEach(topic => topic.isCollapsed = false)">Expand All</button>
          <button type="button" class="btn btn-sm btn-secondary" (click)="topics.forEach(topic => topic.isCollapsed = true)">Collapse All</button>
          <button type="button" class="btn btn-sm btn-primary ml-1" (click)="printReport()" [disabled]="isBusy.isBusy">
            <i class="fa fa-print"></i> Print
          </button>
        </div>
        <div class="inner-scroller flex-scroll">
          @for (topic of topics; track topic.topicId) {
            <div class="phase8-topic">
              <h5 class="tree-name">
                <button type="button" class="btn btn-link p-0 text-left" (click)="toggleTopic(topic)">
                  <i class="fa" [ngClass]="topic.isCollapsed ? 'fa-caret-right' : 'fa-caret-down'"></i>
                  {{topic.topicName}}
                </button>
              </h5>
              @if (!topic.isCollapsed) {
                <ol class="question-list">
                  @for (question of topic.rootQuestions; track question.id) {
                    @if (isQuestionVisible(question)) {
                      <li [class.completed]="question.isComplete" [class.in-progress]="question.hasResponse && !question.isComplete">
                        <a class="question-toggle" [class.active]="currentQuestion?.id === question.id" (click)="selectQuestion(question)">
                          {{question.questionCode}}
                        </a>
                      </li>
                    }
                  }
                </ol>
                @for (group of topic.standards; track group.standardId) {
                  <div class="phase8-standard">
                    <button type="button" class="btn btn-link p-0 text-left" (click)="toggleStandard(group)">
                      <i class="fa" [ngClass]="group.isCollapsed ? 'fa-caret-right' : 'fa-caret-down'"></i>
                      <strong>{{group.standardName}}</strong>
                    </button>
                    @if (!group.isCollapsed) {
                      <ol class="question-list">
                        @for (question of group.questions; track question.id) {
                          @if (isQuestionVisible(question)) {
                            <li [class.completed]="question.isComplete" [class.in-progress]="question.hasResponse && !question.isComplete">
                              <a class="question-toggle" [class.active]="currentQuestion?.id === question.id" (click)="selectQuestion(question)">
                                {{question.questionCode}}
                              </a>
                            </li>
                          }
                        }
                      </ol>
                    }
                  </div>
                }
              }
            </div>
          }
        </div>
      </div>
    </aside>

    <main class="col inspection-body">
      <header class="p-3 mb-3 bg-bdo-secondary">
        <table class="inspection-metadata">
          <tr><th class="pr-2">Engagement Code:</th><td><span class="h5">{{engagement.code}}</span></td></tr>
          <tr><th class="pr-2">Client Name:</th><td><span class="h4">{{engagement.clientName}}</span></td></tr>
          <tr><th class="pr-2">Team Captain:</th><td>{{engagement.teamCaptain}}</td></tr>
          <tr><th class="pr-2">Office:</th><td>{{engagement.officeName}}</td><th class="pr-2">Year:</th><td>{{engagement.inspectionYear}}</td></tr>
          <tr><th class="pr-2">Region:</th><td>{{engagement.regionCode}}</td></tr>
        </table>
      </header>

      @if (!currentQuestion) {
        <p>Please select a question from the navigation.</p>
      }
      @if (currentQuestion) {
        <form #questionForm="ngForm" class="engagement-response-form">
          <div class="d-flex align-items-center mb-2">
            <button type="button" class="btn btn-sm btn-secondary mr-1" [disabled]="!previousQuestion" (click)="goPrevious()"><i class="fa fa-arrow-left"></i><span class="sr-only">Previous</span></button>
            <button type="button" class="btn btn-sm btn-secondary mr-2" [disabled]="!nextQuestion" (click)="goNext()"><i class="fa fa-arrow-right"></i><span class="sr-only">Next</span></button>
            <span>Question <b>{{questionNumber(currentQuestion)}}</b> of <b>{{allQuestions.length}}</b></span>
            @if (currentQuestion.isComplete) { <small class="ml-3 text-success"><i class="fa fa-check"></i> Complete</small> }
            @if (currentQuestion.hasResponse && !currentQuestion.isComplete) { <small class="ml-3 text-muted"><i class="fa fa-asterisk"></i> Saved</small> }
          </div>
          <hr />
          <h4>{{currentQuestion.questionCode}}</h4>
          <div class="lead"><p class="text-pre-wrap">{{currentQuestion.questionText | newline}}</p></div>
          @if (currentQuestion.helpText) {
            <div class="alert alert-info"><i class="fa fa-question-circle"></i> {{currentQuestion.helpText | newline}}</div>
          }

          <fieldset [disabled]="!canEdit" class="mw-800">
            @if (currentQuestion.questionType === questionType.Text) {
              <textarea class="form-control mb-3" rows="6" name="responseText" [(ngModel)]="responseText" (blur)="saveResponse(false)"></textarea>
            }
            @if (currentQuestion.questionType === questionType.Date) {
              <input type="date" class="form-control mb-3" name="responseDate" [(ngModel)]="responseText" (change)="saveResponse(false)" />
            }
            @if (currentQuestion.options?.length && currentQuestion.questionType !== questionType.Text && currentQuestion.questionType !== questionType.Date) {
              <div class="form-group mb-3">
                @for (option of currentQuestion.options; track option.id) {
                  <div class="form-check">
                    <input class="form-check-input"
                      [type]="isMultipleChoice() ? 'checkbox' : 'radio'"
                      [name]="'question-option-' + currentQuestion.id"
                      [checked]="isSelected(option)"
                      (change)="selectOption(option, $any($event.target).checked)"
                      [id]="'question-option-' + option.id" />
                    <label class="form-check-label" [for]="'question-option-' + option.id">
                      {{option.optionText}}
                      @if (isNoAnswer(option)) { <span class="text-muted">(no answer)</span> }
                    </label>
                  </div>
                }
              </div>
            }
            <div class="form-group">
              <label for="phase8-comment">Comment</label>
              <textarea id="phase8-comment" class="form-control" rows="5" name="commentText" [(ngModel)]="commentText"
                placeholder="Add a comment and save it below"></textarea>
            </div>
            <button type="button" class="btn btn-primary mr-2" (click)="saveCurrentAsComplete()" [disabled]="!canEdit || isBusy.isBusy">
              <i class="fa fa-check"></i> Save and complete
            </button>
            <button type="button" class="btn btn-secondary mr-2" (click)="saveResponse(false)" [disabled]="!canEdit || isBusy.isBusy">Save</button>
            <button type="button" class="btn btn-outline-secondary" (click)="clearResponse()" [disabled]="!canEdit || isBusy.isBusy">Clear</button>
          </fieldset>
        </form>
      }
    </main>

    <aside class="col sidebar sidebar-help-text">
      <ul class="nav nav-pills">
        <li class="nav-item"><span class="nav-link active"><i class="fa fa-comments"></i> Comments ({{currentComments.length}})</span></li>
        <li class="nav-item"><span class="nav-link"><i class="fa fa-question-circle"></i> Help</span></li>
      </ul>
      @if (currentQuestion) {
        <div class="inner-scroller">
          <ul class="comments-list">
            @for (comment of currentComments; track comment.id) {
              <li>
                <button type="button" class="btn btn-sm btn-outline-primary float-right" (click)="editComment(comment)">Edit</button>
                <p class="text-pre-wrap">{{comment.text}}</p>
                <small class="text-muted">{{comment.authorName || comment.createdByUserName || comment.inspectionEngagementTeamMemberName}} {{comment.timestamp | date:'yyyy-MM-dd h:mm a'}}</small>
              </li>
            }
          </ul>
          <button type="button" class="btn btn-primary btn-sm" (click)="saveComment()" [disabled]="!canEdit || !commentText.trim() || isBusy.isBusy">Save comment</button>
          @if (currentQuestion.helpText) {
            <div class="my-3"><h5>Question Help</h5><p class="text-pre-wrap">{{currentQuestion.helpText | newline}}</p></div>
          }
        </div>
      }
    </aside>
  </div>
}

<a [routerLink]="['/my-assignments']" class="btn btn-primary mt-3"><i class="fa fa-reply"></i> Return to assignments</a>
